import { render, staticRenderFns } from "./JangkaPendekViewEmail.vue?vue&type=template&id=6b5af39e&scoped=true&lang=pug&"
import script from "./JangkaPendekViewEmail.vue?vue&type=script&lang=js&"
export * from "./JangkaPendekViewEmail.vue?vue&type=script&lang=js&"
import style0 from "./JangkaPendekViewEmail.vue?vue&type=style&index=0&id=6b5af39e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5af39e",
  null
  
)

export default component.exports